require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-patnering-to-increasing-digital-equity-in-k-12.json") })
        }
      }, "path---blog-patnering-to-increasing-digital-equity-in-k-12");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-patnering-to-increasing-digital-equity-in-k-12!./.cache/json/blog-patnering-to-increasing-digital-equity-in-k-12.json
// module id = 1036
// module chunks = 231608221292675